import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const sections = [
  {
    title: '제1조 (개인정보의 처리 목적)',
    content: `영빈호텔(이하 "호텔")은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 객실 예약 및 서비스 제공
고객의 객실 예약 접수, 예약 확인 및 취소, 체크인·체크아웃 처리, 투숙 서비스 제공을 목적으로 개인정보를 처리합니다.

2. 고객 문의 및 불만 처리
고객의 문의사항 접수 및 답변, 불만 처리, 분쟁 해결을 목적으로 개인정보를 처리합니다.

3. 마케팅 및 광고 활용 (동의 시)
이벤트 및 프로모션 안내, 뉴스레터 발송 등을 목적으로 개인정보를 처리합니다.`,
  },
  {
    title: '제2조 (개인정보의 처리 및 보유 기간)',
    content: `호텔은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.

1. 객실 예약 및 서비스 제공 : 서비스 이용 계약 종료 시까지
2. 전자상거래 관련 기록 : 5년 (전자상거래 등에서의 소비자 보호에 관한 법률)
3. 소비자 불만 또는 분쟁 처리 기록 : 3년 (동법)
4. 세금계산서 등 대금결제 기록 : 5년 (국세기본법)`,
  },
  {
    title: '제3조 (처리하는 개인정보의 항목)',
    content: `호텔은 다음의 개인정보 항목을 처리하고 있습니다.

1. 필수항목
- 성명, 연락처(전화번호), 이메일 주소
- 체크인·체크아웃 날짜, 객실 유형, 투숙 인원

2. 선택항목
- 특별 요청 사항, 차량 번호(주차 이용 시)

3. 자동 수집 항목
- 접속 IP 주소, 쿠키, 접속 일시, 서비스 이용 기록`,
  },
  {
    title: '제4조 (개인정보의 제3자 제공)',
    content: `호텔은 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.

현재 호텔은 고객의 개인정보를 제3자에게 제공하고 있지 않습니다.`,
  },
  {
    title: '제5조 (개인정보처리의 위탁)',
    content: `호텔은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

위탁받는 자(수탁자) : 예약 시스템 운영사
위탁하는 업무의 내용 : 객실 예약 시스템 운영 및 관리
위탁 기간 : 서비스 이용 계약 종료 시까지

호텔은 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.`,
  },
  {
    title: '제6조 (정보주체의 권리·의무 및 행사방법)',
    content: `정보주체는 호텔에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.

1. 개인정보 열람 요구
2. 오류 등이 있을 경우 정정 요구
3. 삭제 요구
4. 처리정지 요구

위 권리 행사는 서면, 전화, 전자우편 등을 통하여 하실 수 있으며 호텔은 이에 대해 지체없이 조치하겠습니다.`,
  },
  {
    title: '제7조 (개인정보의 안전성 확보조치)',
    content: `호텔은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

1. 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육
2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제`,
  },
  {
    title: '제8조 (개인정보 자동 수집 장치의 설치·운영 및 거부)',
    content: `호텔은 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.

쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.

이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.`,
  },
  {
    title: '제9조 (개인정보 보호책임자)',
    content: `호텔은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.`,
    highlight: true,
  },
  {
    title: '제10조 (개인정보 처리방침 변경)',
    content: `이 개인정보처리방침은 2024년 1월 1일부터 적용됩니다.

이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.
- 2023년 1월 1일 ~ 2023년 12월 31일 적용 (클릭)`,
  },
];

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '개인정보처리방침 | 영빈호텔';
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    metaRobots.id = 'meta-robots-privacy';
    document.head.appendChild(metaRobots);
    return () => {
      document.title = '영빈호텔 | YOUNGBIN HOTEL';
      const el = document.getElementById('meta-robots-privacy');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sub Header */}
      <div className="pt-20 bg-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <p className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">PRIVACY POLICY</p>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            개인정보처리방침
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">

        {/* Intro */}
        <div className="bg-amber-50 border-l-4 border-amber-600 rounded-r-lg p-6 mb-12">
          <p className="text-gray-700 text-sm leading-relaxed">
            영빈호텔(이하 "호텔")은 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-10">
          {sections.map((sec) => (
            <div key={sec.title}>
              <h4 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-stone-100">
                <a id={sec.title}>{sec.title}</a>
              </h4>
              {sec.highlight ? (
                <>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">{sec.content}</p>
                  {/* 개인정보 보호책임자 카드 */}
                  <div className="bg-stone-50 rounded-lg p-6 border border-stone-200">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                        <i className="ri-user-settings-line text-amber-700 text-xl" />
                      </div>
                      <div className="flex flex-col gap-2">
                        <p className="text-xs text-amber-700 font-semibold tracking-widest uppercase mb-1">개인정보 관리담당자</p>
                        <p className="text-gray-900 font-bold text-base">권대성</p>
                        <div className="flex flex-col sm:flex-row gap-3 mt-1">
                          <a
                            href="tel:0222771141"
                            className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-700 transition-colors cursor-pointer"
                          >
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-phone-line text-amber-600" />
                            </div>
                            02-2277-1141
                          </a>
                          <a
                            href="mailto:youngbinhotel@hotmail.com"
                            className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-700 transition-colors cursor-pointer"
                          >
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-mail-line text-amber-600" />
                            </div>
                            youngbinhotel@hotmail.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                    정보주체께서는 호텔의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 호텔은 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
                  </p>
                </>
              ) : (
                <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">{sec.content}</p>
              )}
            </div>
          ))}
        </div>

        {/* 기타 권익침해 구제 */}
        <div className="mt-14 bg-stone-50 rounded-lg p-6 border border-stone-200">
          <h4 className="text-sm font-bold text-gray-900 mb-3">
            <a id="권익침해">권익침해 구제 방법</a>
          </h4>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
          </p>
          <ul className="flex flex-col gap-2">
            {[
              { name: '개인정보분쟁조정위원회', tel: '1833-6972', url: 'www.kopico.go.kr' },
              { name: '개인정보침해신고센터', tel: '118', url: 'privacy.kisa.or.kr' },
              { name: '대검찰청 사이버범죄수사단', tel: '02-3480-3573', url: 'www.spo.go.kr' },
              { name: '경찰청 사이버안전국', tel: '182', url: 'cyberbureau.police.go.kr' },
            ].map((item) => (
              <li key={item.name} className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 text-xs text-gray-500">
                <strong className="text-gray-700 w-44">{item.name}</strong>
                <span>전화: {item.tel}</span>
                <span className="text-amber-700">{item.url}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Back button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 border border-stone-300 text-gray-700 rounded-full text-sm hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            메인으로 돌아가기
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
